import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3367d076"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "budgetReport"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title",
    style: {
      "margin-top": "0"
    }
  }, "预算概况", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, " 费用预算 ", -1);
});
var _hoisted_5 = {
  class: "num"
};
var _hoisted_6 = {
  class: "desc"
};
var _hoisted_7 = {
  class: "box mb-4"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, " 专项报表 ", -1);
});
var _hoisted_9 = {
  class: "num"
};
var _hoisted_10 = {
  class: "desc"
};
var _hoisted_11 = {
  class: "box"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, " 物流预算 ", -1);
});
var _hoisted_13 = {
  class: "num"
};
var _hoisted_14 = {
  class: "desc"
};
var _hoisted_15 = {
  class: "box"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, " 销售预收 ", -1);
});
var _hoisted_17 = {
  class: "num"
};
var _hoisted_18 = {
  class: "desc"
};
var _hoisted_19 = {
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_budget_item = _resolveComponent("budget-item");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_bar_echart_mul = _resolveComponent("bar-echart-mul");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_pie_echart = _resolveComponent("pie-echart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_budget_item, {
    item: _ctx.budgetSurvey
  }, null, 8, ["item"]), _hoisted_4, _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.costBudgetTotal, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.desc
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [_ctx.costBudgetData.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.costBudgetData)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))]), _hoisted_8, _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectBudgetTotal, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.desc
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.projectBudgetData)), null, 16)]), _hoisted_12, _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logisticsBudgetTotal, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.desc
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_15, [_createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.logisticsBudgetData)), null, 16)]), _hoisted_16, _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 1
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleAdvanceReceiptTotal, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.desc
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_19, [_createVNode(_component_pie_echart, _normalizeProps(_guardReactiveProps(_ctx.saleAdvanceReceiptData)), null, 16)])])]);
}